import { CardComponent } from "./CardComponent.tsx";
import { Empty } from "antd";
import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks.ts";
import { useScrollablePagination } from "../../hooks/useScrollablePagination.ts";
import { CoreLoading } from "../common/CoreLoading.tsx";
import { onFilterFolders } from "../../utils/folders/filters.ts";
import { fetchAllFolders } from "../../redux/actions/folderActions";

export const Cards: React.FC = () => {
  const {
    results: folders,
    loading,
    filterChoice,
    sortingChoice,
    filterDates,
    filterUser,
  } = useAppSelector((state) => state.folder);
  const dispatch = useAppDispatch();

  const folderListRef = useRef<HTMLDivElement | null>(null);

  useScrollablePagination(folderListRef, fetchAllFolders);

  const onFilter = async () => {
    if (filterChoice === "user" && !filterUser) return;

    await onFilterFolders(
      filterChoice,
      sortingChoice,
      filterDates,
      filterUser,
      null,
      dispatch,
    );
  };

  useEffect(() => {
    onFilter();
  }, [filterChoice, sortingChoice, filterDates, filterUser]);

  if (loading) {
    return <CoreLoading size={2} />;
  }

  return (
    <div
      className="w-full flex flex-col justify-center items-center"
      ref={folderListRef}
    >
      {folders.length > 0
        ? folders.map((folder, index) => (
            <CardComponent key={index} folder={folder} detailed />
          ))
        : !loading && (
            <div className="mx-auto mt-24">
              <Empty description="Prueba otro criterio de búsqueda" />
            </div>
          )}
    </div>
  );
};
